import loadIframe from '../packs/main';

// packages
import { Component, h } from 'preact';

// internal
import serializeQueryString from '../utils/serialize-query-string';

class GranicusViewer extends Component {
  constructor() {
    super();

    this.state = { height: null };

    this.onDocumentResize = this.onDocumentResize.bind(this);
  }

  componentDidMount() {
    this.getParentHeight();
    const { subdomain } = this.props;
    const iframeId = `iframe-${subdomain}`;

    // loadIframe(iframeId);

    window.addEventListener('resize', this.onDocumentResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onDocumentResize, false);
  }

  getParentHeight() {
    const { height } = this.base.parentNode.getBoundingClientRect();

    this.setState({ height });
  }

  onDocumentResize() {
    this.getParentHeight();
  }

  buildGranicusUrl() {
    const { params, subdomain } = this.props;
    const streamUrl = `https://${subdomain}.granicus.com/mediaplayer.php?${serializeQueryString(
      { embed: 1, ...params }
    )}`;

    // const streamUrl = ` https://tlcsenate.granicus.com/mediaplayer.php?camera_id=5&embed=1&autoplay=0`

    return streamUrl;
  }

  render() {
    const { height } = this.state;
    const { subdomain } = this.props;
    const iframeId = `iframe-${subdomain}`;
    const buildURL = path => `${process.env.PUBLIC_PATH}${path}`;

    if (!height) return null;

    const src = this.buildGranicusUrl();

    return (
      <div>
        <div class="video-watermark">
          <img
            alt="Texas Tribune"
            src={buildURL('assets/images/watermark.png')}
          />
        </div>
        <iframe
          title={iframeId}
          id={iframeId}
          frameborder="0"
          scrolling="no"
          width="100%"
          height={height}
          src={src}
        />
      </div>
    );
  }
}

export default GranicusViewer;
